import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const DutyRoomPage = lazy(() => import('./pages/DutyRoom'));
const EncountersPage = lazy(() => import('./pages/Encounters'));
const EncounterRoomPage = lazy(() => import('./pages/EncounterRoom'));

const doctor = (el: React.ReactNode) => <RequireAuth roles={['DOCTOR']}>{el}</RequireAuth>;

/** Plantão e atendimento do lado do médico (F-07 · T-34 · T-35) — usa o DoctorPanel do módulo DoctorArea. */
const routes: RouteObject[] = [
  { path: '/medico/plantao', element: doctor(<DutyRoomPage />) },
  { path: '/medico/atendimentos', element: doctor(<EncountersPage />) },
  { path: '/medico/atendimento/:id', element: doctor(<EncounterRoomPage />) },
];
export default routes;
